//@ts-check
import React from 'react';
import { useFilterContext } from './FilterContext';
import { useTheme } from '@material-ui/core/styles';
import DropdownButton from '../../../core/DropdownButton';
/**
 * @param {import('./types').EcrionFilterType} type
 */

var getCaption = function getCaption(type) {
  if (type === 'AND') return 'and';
  if (type === 'OR') return 'or';
  return '-';
};
/**
 * @param {import('./types').FormInputFilterTypeProps & { isLast?: boolean } } props
 */


var FilterTypeFormInput = function FilterTypeFormInput(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      isLast = _ref.isLast,
      expIdx = _ref.expIdx;

  var _useFilterContext = useFilterContext(),
      disabled = _useFilterContext.disabled;

  var theme = useTheme();
  return React.createElement("div", {
    style: {
      marginLeft: isLast ? -theme.spacing(1.5) : 0,
      marginBottom: theme.spacing(1),
      opacity: 0.8
    }
  }, React.createElement(DropdownButton, {
    options: [{
      value: 'AND',
      label: getCaption('AND'),
      onClick: function onClick() {
        return onChange('AND', {
          expIdx: expIdx
        });
      }
    }, {
      value: 'OR',
      label: getCaption('OR'),
      onClick: function onClick() {
        return onChange('OR', {
          expIdx: expIdx
        });
      }
    }],
    type: "menu-down",
    label: getCaption(value),
    labelPlacement: "start",
    buttonSize: "small",
    disabled: disabled
  }));
};

FilterTypeFormInput.defaultProps = {};
export default React.memo(FilterTypeFormInput);